import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { openSendPopupForContact } from './slice'

export const SendFromCalendlyWrapper = ({ contact, source, trackingSource }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(openSendPopupForContact({ contact, source, trackingSource }))
  }, [dispatch, contact, source, trackingSource])

  return null
}
